// extracted by mini-css-extract-plugin
export default {"addCardModal":"AddCard_addCardModal__ZaVRL","closeModal":"AddCard_closeModal__yBYMx","header":"AddCard_header__Wsizy"};